import React, { useEffect, useState } from "react";
import { Table, Button, Popover, Input, Popconfirm, message } from "antd";
import { CONSTANTS } from "../../../utils/constant";
import {removeMedicalTest} from "../../../store/slice/medicaltest-slice";
import { connect } from "react-redux";
import icons from "Common/Icons";
import SubmitButton from "../../../Pages/Patient/SubmitButton";
import "./MedicalTest.scss";
function MedicalTestTable(props) {
  const [ columns , setColumns ] = useState([]);

  const [ table_data , setTableData ] = useState([]);

  useEffect(() => {   
    
    if(props?.test_array?.length>0 && !props.is_prescription_report){
      setTableData(props.test_array)
    }
    if(props.test_array.test_id && !props.is_prescription_report)
    
      setTableData([...table_data, props.test_array])
      let columns = [
      {
        title: `S.No.`,
        width: "20px",
        key: "index",
        align: "left",
         render: (data, record, index) => <span>{index + 1}</span>,
      },
      {
        title: (           
              <p style={{ margin: "0px auto" }}>{`${CONSTANTS.TEST_NAME}`}</p>
        ),
        width: "450px",
        key: "name",
        align: "left",
        render: (data) => (
          <>
            {data?.test_id?.split("_")?.[1]}
           
          </>
        ),
      },
     
      {
        title: `${CONSTANTS.INSTRUCTION}`,
        width: "30px",
        key: "instructions",
        align: "center",
         render: (data,record) =>  (
          <>
          
             {record?.instructions?.trim().length>0? (
              <Popover id="medical-test-instruction" content={record.instructions} title="Instruction">
                <img
                  style={{ cursor: "pointer", height: "25px" }}
                  src={icons.instruction}
                />
              </Popover>
            ) : null}
          
          </>
         ),
      },
      {
        title: `${CONSTANTS.ACTION} `,
        width: "150px",
        key: "date",        
         render: (data,record,index) => <div className="btn-wrapper">
          <Button style={{color:"blue",border:"none",boxShadow:"none",margin:"0px",padding:"0px"}} className={"edit-btn"} onClick={()=>editTest(data,index)}>Edit</Button>
          <Button style={{color:"red",border:"none",boxShadow:"none"}} className={"del-btn"} onClick={()=>deleteTest(index)}>Delete</Button>
          </div>,
      },
     
   
  
    ];
    columns = props?.is_prescription_report ?  columns.slice(0,-1) : columns ;
    setColumns(columns)
  }, [props.test_array,props.is_prescription_report]);
 
  useEffect(()=>{
    setTableData(props?.retain_test)
  },[props.retain_test])

  const deleteTest=(index)=>{
    if(props.is_edit){
      message.error("Please add/cancel the exisiting changes!.", ErrorDuration)
          }else{

    setTableData((table_data) => {
     
    let temp=table_data.filter((item, i) => i !== index);
    return temp
   })}
   
  }
  
  const editTest=(data,index)=>{

    if(props.is_edit){
message.error("Please add/cancel the exisiting changes!.", ErrorDuration)
    }else{
    props.edit_test(data)
    deleteTest(index)
    }
  }

 const saveTest=()=>{
  props.saveTest(table_data)
 }
  return (
    <>
    <div className="medical-test-table">
     <Table
     scroll={{x: "750px"}}
      style={{ margin: "20px 0px" }}
      pagination={false}
      columns={columns}
      dataSource={table_data}
      className={"medical-test-table"}
      />
      
    </div>
    {!props?.is_prescription_report &&
      <div className="submit-button-wrapper">
      <SubmitButton className={"confirm-btn sub-btn"} label={"Save and Preview"} onClick={()=>saveTest()} loading={props?.is_save} disabled={table_data?.length>0?false:true}/> 
      </div>
}
      </>
  );

}

const mapStateToProps = (state) => {  
  return {
    t_table_data: state.medicaltestReducer ,
  };
};

const mapDispatchToProps = {
 removeMedicalTest
};

export default  connect(mapStateToProps, mapDispatchToProps)(MedicalTestTable);
